const textFieldFormParamFreq = {
  name: 'Nombre',
  value: 'Valor'
};

export default textFieldFormParamFreq;
